import moment from 'moment';

export default function genererCritereRechercheEcheancesARapprocher() {
  return {
    modesReglementsIds: [],
    agencesIds: [],
    datesEcheance: {
      dateDebut: (moment().startOf('month')).toDate(),
      dateFin: (moment().endOf('month')).toDate(),
    },
    dateFinContrat: {
      dateDebut: null,
      dateFin: null,
    },
    etatContrat: null,
    codeAvenantBail: '',
    codeFace: '',
    nomBailleur: '',
    montantEcheanceHt: null,
    montantEcheanceTtc: null,
    villePanneau: '',
    blocageReglement: false,
    motifBlocage: '',
    motifsBlocagesId: [],
    commentaire: '',
    adresse: null,
    estIndexe: null,
  };
}
